import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import LogoUpd from "../../icons/svg/LogoUpd"

const Logo = ({ to, text }) => {


  return(
    <Link id="logo" to={to} className="logo" title={text}>
      <div className="logo-wrapper">
        <LogoUpd/>
      </div>
    </Link>
)};

Logo.propTypes = {
  to: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default Logo;
